export default {
  section2Item1Title: {
    id: 'product_page_condition_comparison_modal_section2_item1_title',
    defaultMessage: 'Both tested. Perfected. Refurbished.',
  },
}
